/**
 * Feature Capabilities (frontend mirror of backend config/capabilities.ts)
 *
 * Resolves which product modules a workspace exposes from its platform, so the UI
 * (navigation, route guards) shows commerce features only for commerce workspaces
 * and hides them for STANDALONE sales-team workspaces. Kept deliberately in sync
 * with the backend resolver.
 */

export interface Capabilities {
  // Shared core (always on)
  conversations: boolean;
  contacts: boolean;
  broadcasts: boolean;
  templates: boolean;
  automations: boolean;
  flows: boolean;
  routing: boolean;
  analytics: boolean;
  qrCodes: boolean;

  // Commerce modules (on only when an e-commerce platform is connected)
  orders: boolean;
  products: boolean;
  catalog: boolean;
  cod: boolean;
  reviews: boolean;
  payments: boolean;
  productSync: boolean;
}

const CORE = {
  conversations: true,
  contacts: true,
  broadcasts: true,
  templates: true,
  automations: true,
  flows: true,
  routing: true,
  analytics: true,
  qrCodes: true,
}

const COMMERCE_ON = {
  orders: true,
  products: true,
  catalog: true,
  cod: true,
  reviews: true,
  payments: true,
  productSync: true,
}

const COMMERCE_OFF = {
  orders: false,
  products: false,
  catalog: false,
  cod: false,
  reviews: false,
  payments: false,
  productSync: false,
}

export function isCommercePlatform(platform?: string | null): boolean {
  return !!platform && platform !== 'STANDALONE'
}

export function capabilitiesForPlatform(platform?: string | null): Capabilities {
  return {
    ...CORE,
    ...(isCommercePlatform(platform) ? COMMERCE_ON : COMMERCE_OFF),
  }
}
